<template>
  <b-card>
    <!-- filter  -->
    <div
      v-if="loading"
      class="text-center mt-4"
    >
      <b-spinner label="Loading..." />
    </div>
    <div class="col-12 mt-16">
      <div>
        <b-row class="align-items-center">
          <b-col
            lg="4"
            class="my-1"
          >
            <b-form-group
              label=""
              label-for="filter-input"
              label-cols-sm="1"
              label-align-sm="right"
              label-size="sm"
              class="mb-0"
            >
              <b-input-group size="sm">
                <b-form-input
                  id="filter-input"
                  v-model="filter"
                  type="search"
                  placeholder="Type to Search"
                />
                <b-input-group-append>
                  <b-button
                    :disabled="!filter"
                    variant="primary"
                    @click="applyFilter"
                  >Apply</b-button>
                  <b-button
                    :disabled="!filter"
                    @click="clearFilter"
                  >
                    Clear
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <!-- .. Filter  for   date-->
          <b-col
            lg="3"
            class="my-1"
          >
            <b-form-input
              id="start-date"
              v-model="startDateFilter"
              type="date"
              placeholder="Select start date"
            />
          </b-col>
          <b-col
            lg="3"
            class="my-1"
          >
            <b-form-input
              id="end-date"
              v-model="endDateFilter"
              type="date"
              placeholder="Select end date"
              @change="changeDate"
            />
          </b-col>
          <!-- Filter  for   date-  -->

          <input
            ref="fileInput"
            type="file"
            accept=".csv"
            style="display: none;"
            @change="handleFileUpload"
          >
          <b-col
            lg="2"
            class="my-1 d-flex justify-content-end"
          >
            <b-button
              variant="primary"
              class="mb-8 mr-8"
              @click="exportAllDataToCSV"
            >
              Export
            </b-button>
          </b-col>
        </b-row>
      </div>
    </div>

    <!-- filter end -->
    <b-row>
      <div class="col-12 mt-16">
        <b-skeleton-table
          v-if="loading"
          :rows="perPage"
          :columns="fields.length"
          animation="wave"
          bordered
          class="mb-3"
        />
        <b-table
          v-else
          id="dataTable"
          :items="users"
          :busy.sync="loading"
          :fields="fields"
          :current-page="currentPage"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          show-empty
          responsive
          striped
          hover
          class="custom-zebra"
        >
          <template v-slot:head()="data">
            <span :style="{ color: columnColors[data.field.key] }">{{ data.label }}</span>
          </template>
          <template v-slot:cell()="row">
            <span :style="{ color: columnColors[row.field.key] }">{{ row.value || 'N/A' }}</span>
          </template>

          <template #cell(vehicle_name)="row">
            {{ row.item.vehicle ? row.item.vehicle.name : 'N/A' }}
          </template>
          <template #cell(vehicle_type)="row">
            {{ row.item.vehicle ? row.item.vehicle.vehicle_type : 'N/A' }}
          </template>

          <template #cell(owner_name)="row">
            <span :style="{ color: columnColors.owner_name }">{{ row.item.user?.first_name }} {{
                            row.item.user?.last_name }}</span>
          </template>

          <template #cell(uic)="row">
            <span :style="{ color: columnColors.uic }">{{ row.item.uic || 'N/A' }}</span>
          </template>

          <template #cell(color)="row">
            <span :style="{ color: columnColors.color }">{{ row.item.color || 'N/A' }}</span>
          </template>

          <template #cell(license_plate)="row">
            <span :style="{ color: columnColors.license_plate }">{{ row.item.license_plate || 'N/A'
            }}</span>
          </template>

          <template #cell(registration_number)="row">
            <span :style="{ color: columnColors.registration_number }">{{ row.item.registration_number
              || 'N/A' }}</span>
          </template>

          <template #cell(status)="row">
            <span :style="{ color: columnColors.status }">{{ row.item.status || 'N/A' }}</span>
          </template>

          <template #cell(SystemNo)="row">
            <b-button
              v-b-tooltip.hover
              title=" System No."
              :variant="row.item.status === '' ? 'warning' : 'primary'"
              class="mb-8 mr-8"
              @click="handleSystemNo(row.item)"
            >
              <span :style="{ color: columnColors.SystemNo }">{{ row.item.SystemNo || 'Add SystemNo' }}
              </span>
            </b-button>
            <b-modal
              v-model="addSystemNo"
              title="Add System No."
            >
              <b-form-group
                label="SystemNo:"
                label-for="SystemNo"
              >
                <b-form-input
                  id="SystemNo"
                  v-model="SystemNo"
                  placeholder="Enter SystemNo"
                  required
                />
              </b-form-group>

              <b-spinner
                v-if="loading"
                label="Processing..."
              />

              <template #modal-footer>
                <b-button
                  :disabled="loading"
                  variant="primary"
                  @click="confirmSystemNo"
                >
                  Add
                </b-button>
                <b-button
                  :disabled="loading"
                  variant="secondary"
                  @click="addSystemNo = false"
                >Cancel</b-button>
              </template>
            </b-modal>

          </template>
          <template #cell(InvoiceNo)="row">
            <b-button
              v-b-tooltip.hover
              title=" Invoice Number"
              :variant="row.item.status === '' ? 'warning' : 'primary'"
              class="mb-8 mr-8"
              @click="handleInvoiceNo(row.item)"
            >
              <span :style="{ color: columnColors.InvoiceNo }">{{ row.item.InvoiceNo || 'Add Invoice Number' }}
              </span>
            </b-button>
            <b-modal
              v-model="addInvoiceNo"
              title="Add Invoice Number"
            >
              <b-form-group
                label="Invoice Number:"
                label-for="Invoice Number"
              >
                <b-form-input
                  id="InvoiceNo"
                  v-model="InvoiceNo"
                  placeholder="Enter Invoice Number"
                  required
                />
              </b-form-group>

              <b-spinner
                v-if="loading"
                label="Processing..."
              />

              <template #modal-footer>
                <b-button
                  :disabled="loading"
                  variant="primary"
                  @click="confirmInvoiceNo"
                >
                  Add
                </b-button>
                <b-button
                  :disabled="loading"
                  variant="secondary"
                  @click="addInvoiceNo = false"
                >Cancel</b-button>
              </template>
            </b-modal>

          </template>

          <template #cell(year)="row">
            <span :style="{ color: columnColors.year }">{{ row.item.year || 'N/A' }}</span>
          </template>

          <template #cell(title)="row">
            <span :style="{ color: columnColors.title }">{{ row.item.model?.title || 'N/A' }}</span>
          </template>

          <template #cell(name)="row">
            <span :style="{ color: columnColors.name }"> {{ row.item.brand?.name || 'N/A' }}</span>
          </template>

          <template #cell(Category_title)="row">
            <span :style="{ color: columnColors.Category_title }">{{ row.item.category?.title || 'N/A' }}
            </span>
          </template>

          <template v-slot:cell(created_at)="data">
            {{ formatDate(data.item.created_at) }}
          </template>
          <template v-slot:cell(created_at_time)="data">
            {{ formatTime(data.item.created_at) }}
          </template>

          <template #cell(stolen_location)="data">
            <button
              class="btn btn-link"
              style="color: red;"
              @click="stolenVehicle(data.item)"
            >
              {{ data.item.stolen_location }}
            </button>
          </template>

          <template #cell(types)="row">
            <b-button
              v-b-tooltip.hover
              title="Change the Vehicle Type to Approved or Pending"
              :variant="row.item.types === 'Pending' ? 'warning' : 'primary'"
              class="mb-8 mr-8"
              @click="handleApproved(row.item)"
            >
              {{ row.item.types }}
            </b-button>
          </template>
          <template #cell(manager)="row">
            <b-button
              v-b-tooltip.hover
              title="Assign Manager to this Vehicle"
              size="sm"
              variant="primary"
              @click="openManagerAssignModal(row.item)"
            >
              {{ row.item.manager?.first_name || 'Assign Manager' }}
            </b-button>
          </template>

          <template #cell(actions)="row">
            <b-button
              v-b-tooltip.hover
              title="Show Vehicle"
              variant="link"
              class="p-0"
              @click="showParent(row.item.id)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                fill="currentColor"
                style="
                color: rgba(0, 255, 195, 0.87);
                margin-left: 6px;
                margin-bottom: 10px;
              "
                class="bi bi-eye"
                viewBox="0 0 16 16"
              >
                <path
                  d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"
                />
                <path
                  d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"
                />
              </svg>
            </b-button>
            <!-- delete -->
            <b-button
              v-b-tooltip.hover
              title="Delete Vehicle"
              variant="link"
              class="p-0 btn-sm mr-2"
              @click="showDeleteConfirmation(row.item.id)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                fill="currentColor"
                style="color: red; margin-left: 6px; margin-bottom: 10px"
                class="bi bi-eye"
                viewBox="0 0 16 16"
              >
                <!-- ... your SVG path ... -->
                <path
                  d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z"
                />
              </svg>
            </b-button>
            <!-- Theft  Modal  code  here  -->
            <b-modal
              id="theft-vehicle-modal"
              v-model="showModal"
              title="Confirm Theft Vehicle"
            >
              <p>Are you sure you want to mark this vehicle as stolen?</p>
              <template #modal-footer>
                <b-button
                  variant="primary"
                  @click="confirmTheft"
                >
                  Confirm
                </b-button>
                <b-button
                  variant="primary"
                  @click="showModal = false"
                >
                  Cancel
                </b-button>
              </template>
            </b-modal>

            <!-- Theft  Modal  code end here  -->
            <b-modal
              v-model="showDeleteConfirmations"
              title="Delete Confirmation"
            >
              <p>Are you sure you want to delete this vehicle?</p>
              <template #modal-footer>
                <b-button
                  variant="primary"
                  @click="deleteItem(itemIdToDelete)"
                >
                  Delete
                </b-button>
                <!-- <b-button variant="danger" @click="markVehicleAsStolen(itemIdToDelete)">Mark as Stolen</b-button> -->
                <b-button
                  variant="primary"
                  @click="showDeleteConfirmations = false"
                >
                  Cancel
                </b-button>

              </template>
            </b-modal>
            <!-- end delete -->
            <!-- Edit code here  -->
            <b-button
              v-b-tooltip.hover
              title="Edit Vehicle"
              variant="link"
              class="p-0"
              @click="editUser(row.item.id)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                fill="currentColor"
                style="color: orange; margin-left: 10px; margin-bottom: 10px"
                class="bi bi-pencil"
                viewBox="0 0 16 16"
              >

                <path
                  d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"
                />
              </svg>
            </b-button>

                        &nbsp;
            <b-button
              v-b-tooltip.hover
              title="Report the Theft Vehicle"
              variant="primary"
              class="btn-sm mb-8 mr-2"
              @click="showTheftModal(row.item.id)"
            >
              Theft Vehicle
            </b-button>
                        &nbsp;
            <b-button
              v-b-tooltip.hover
              title="Vehicle PDF in English"
              variant="primary"
              class="btn-sm mb-8 mr-2"
              @click="generatePdf(row.item.id)"
            >
              <i class="fas fa-file-pdf" /> &nbsp;Pdf
            </b-button>
                        &nbsp;
            <b-button
              v-b-tooltip.hover
              title="Vehicle PDF in Spanish"
              variant="primary"
              class="btn-sm mb-8 mr-2"
              @click="generatePdfSpanish(row.item.id)"
            >
              <i class="fas fa-file-pdf" /> &nbsp;Spanish
            </b-button>

          </template>

          <b-form-group
            label="Filter"
            label-for="filter-input"
            label-cols-sm="3"
            label-align-sm="right"
            label-size="sm"
            class="mb-0"
          >
            <b-input-group size="sm">
              <b-form-input
                id="filter-input"
                v-model="filter"
                type="search"
                placeholder="Type to Search"
              />

              <b-input-group-append>
                <b-button
                  :disabled="!filter"
                  @click="filter = ''"
                >
                  Clear
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-table>

        <!-- Assign Manager Modal -->
        <b-modal
          v-model="assignManagerModal"
          title="Assign Manager"
        >
          <div v-if="loadingManagerList">
            <b-spinner
              label="Loading..."
              small
            /> Loading managers...
          </div>
          <div v-else>
            <b-form-group label="Select a Manager">
              <b-form-select
                v-model="selectedManagerId"
                :options="Array.isArray(managerList) ? managerList.map(manager => ({
                  value: manager.id,
                  text: (manager.first_name || '') + (manager.last_name ? ' ' + manager.last_name : '') + ' (' + manager.email + ')'
                })) : []"
                placeholder="Choose one"
              />
            </b-form-group>
          </div>
          <template #modal-footer>
            <b-button
              variant="secondary"
              @click="assignManagerModal = false"
            >
              Cancel
            </b-button>
            <b-button
              variant="primary"
              :disabled="!selectedManagerId"
              @click="assignManager"
            >
              Assign
            </b-button>
          </template>
        </b-modal>
        <!-- End Assign Manager Modal -->

        <div class="mx-8 d-flex justify-content-end">
          <b-pagination
            v-model="currentPage"
            :total-rows="total"
            :per-page="perPage"
            aria-controls="dataTable"
            @change="pageChanged"
          />
        </div>
        <b-row class="mt-16 align-items-center justify-content-end">
          <b-row />
        </b-row>
      </div>
    </b-row>

    <!-- Soft-deleted vehicles -->
    <div
      v-if="!deletedVehiclesDismissed"
      class="deleted-archive-panel mt-4"
    >
      <div class="deleted-archive-header d-flex align-items-center justify-content-between px-3 py-2">
        <div class="d-flex align-items-center text-muted small font-weight-bold text-uppercase letter-spacing">
          <b-icon
            icon="trash"
            class="mr-2"
            font-scale="0.95"
          />
          Deleted vehicles
        </div>
        <div class="d-flex align-items-center">
          <b-button
            variant="light"
            size="sm"
            class="py-0 px-2 archive-toggle-btn"
            :aria-expanded="deletedVehiclesExpanded ? 'true' : 'false'"
            @click="toggleDeletedVehiclesExpand"
          >
            {{ deletedVehiclesExpanded ? '−' : '+' }}
          </b-button>
          <b-button
            v-b-tooltip.hover
            variant="light"
            size="sm"
            class="py-0 px-2 ml-1 archive-toggle-btn"
            title="Hide section"
            @click="deletedVehiclesDismissed = true"
          >
            ×
          </b-button>
        </div>
      </div>
      <div
        v-show="deletedVehiclesExpanded"
        class="deleted-archive-body border-top px-3 pb-3 pt-3"
      >
        <b-row class="align-items-end mb-3">
          <b-col
            cols="12"
            md="5"
            class="mb-2 mb-md-0"
          >
            <b-button-toolbar aria-label="Export deleted vehicles">
              <b-button-group
                size="sm"
                class="flex-wrap"
              >
                <b-button
                  variant="outline-secondary"
                  @click="copyDeletedVehiclesTable"
                >
                  COPY
                </b-button>
                <b-button
                  variant="outline-secondary"
                  @click="exportDeletedVehiclesCsv"
                >
                  CSV
                </b-button>
                <b-button
                  variant="outline-secondary"
                  @click="exportDeletedVehiclesExcel"
                >
                  EXCEL
                </b-button>
                <b-button
                  variant="outline-secondary"
                  @click="exportDeletedVehiclesPdf"
                >
                  PDF
                </b-button>
                <b-button
                  variant="outline-secondary"
                  @click="printDeletedVehiclesTable"
                >
                  PRINT
                </b-button>
              </b-button-group>
            </b-button-toolbar>
          </b-col>
          <b-col
            cols="6"
            md="2"
            class="mb-2 mb-md-0"
          >
            <label class="small text-muted mb-1 d-block">Deleted from</label>
            <b-form-input
              v-model="deletedVehiclesStartDate"
              type="date"
              size="sm"
            />
          </b-col>
          <b-col
            cols="6"
            md="2"
            class="mb-2 mb-md-0"
          >
            <label class="small text-muted mb-1 d-block">Deleted to</label>
            <b-form-input
              v-model="deletedVehiclesEndDate"
              type="date"
              size="sm"
            />
          </b-col>
          <b-col
            cols="12"
            md="3"
          >
            <label class="small text-muted mb-1 d-block">Search</label>
            <b-input-group size="sm">
              <b-form-input
                v-model="deletedVehiclesFilter"
                type="search"
                placeholder="Search"
                @keyup.enter="applyDeletedVehiclesSearch"
              />
              <b-input-group-append>
                <b-button
                  variant="primary"
                  :disabled="!deletedVehiclesFilter"
                  @click="applyDeletedVehiclesSearch"
                >
                  Apply
                </b-button>
                <b-button
                  :disabled="!deletedVehiclesFilter"
                  @click="clearDeletedVehiclesSearch"
                >
                  Clear
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-col>
        </b-row>
        <b-row
          v-if="deletedVehiclesStartDate || deletedVehiclesEndDate"
          class="mb-2"
        >
          <b-col>
            <b-button
              size="sm"
              variant="outline-secondary"
              @click="clearDeletedVehiclesDateFilter"
            >
              Clear date filter
            </b-button>
          </b-col>
        </b-row>
        <div
          v-show="deletedVehiclesLoading"
          class="text-center py-3"
        >
          <b-spinner small />
        </div>
        <div
          v-show="!deletedVehiclesLoading"
          ref="deletedVehiclesPdf"
          class="deleted-vehicles-print-area"
        >
          <b-table
            :items="deletedVehiclesList"
            :fields="deletedVehiclesFields"
            show-empty
            responsive
            striped
            hover
            small
            empty-text="No deleted vehicles found."
            class="custom-zebra mb-0"
          >
            <template #cell(brand_model)="row">
              {{ row.item.brand_model }}
            </template>
            <template #cell(owner_display)="row">
              {{ row.item.owner_display }}
            </template>
            <template #cell(status)="row">
              <b-badge
                :variant="row.item.status ? 'info' : 'light'"
                class="text-uppercase"
              >
                {{ row.item.status || '—' }}
              </b-badge>
            </template>
            <template #cell(deleted_at_display)="row">
              {{ row.item.deleted_at_display }}
            </template>
            <template #cell(actions)="row">
              <b-button
                v-b-tooltip.hover
                title="Restore vehicle"
                variant="link"
                class="p-0 restore-action-btn"
                @click="openRestoreVehicleModal(row.item)"
              >
                <i
                  class="fas fa-undo-alt"
                  aria-hidden="true"
                />
              </b-button>
            </template>
          </b-table>
        </div>
        <div class="d-flex justify-content-end mt-2">
          <b-pagination
            v-if="deletedVehiclesTotal > 0"
            v-model="deletedVehiclesCurrentPage"
            :total-rows="deletedVehiclesTotal"
            :per-page="deletedVehiclesPerPage"
            size="sm"
            class="mb-0"
            @change="deletedVehiclesPageChanged"
          />
        </div>
      </div>
    </div>
    <div
      v-else
      class="mt-3"
    >
      <b-button
        variant="link"
        size="sm"
        class="p-0"
        @click="deletedVehiclesDismissed = false"
      >
        Show deleted vehicles
      </b-button>
    </div>

    <b-modal
      v-model="showRestoreVehicleModal"
      title="Restore vehicle"
      hide-footer
      centered
    >
      <p class="mb-0">
        Restore vehicle <strong>#{{ restoreVehicleId }}</strong> back to the active vehicle list?
      </p>
      <div class="d-flex justify-content-end mt-3">
        <b-button
          variant="secondary"
          class="mr-2"
          @click="showRestoreVehicleModal = false"
        >
          Cancel
        </b-button>
        <b-button
          variant="primary"
          :disabled="restoreVehicleSubmitting"
          @click="confirmRestoreVehicle"
        >
          <b-spinner
            v-if="restoreVehicleSubmitting"
            small
            class="mr-1"
          />
          Restore
        </b-button>
      </div>
    </b-modal>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BButton,
  BTable,
  BFormGroup,
  BInputGroup,
  BFormInput,
  BFormSelect,
  BPagination,
  BInputGroupAppend,
  BSpinner,
  BSkeletonTable,
  BBadge,
  BButtonToolbar,
  BButtonGroup,
} from 'bootstrap-vue'
import Papa from 'papaparse'
import axios from '../../../axios'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    BTable,
    BFormGroup,
    BInputGroup,
    BFormInput,
    BFormSelect,
    BPagination,
    BInputGroupAppend,
    BSpinner,
    BSkeletonTable,
    BBadge,
    BButtonToolbar,
    BButtonGroup,
  },
  props: ['notification'],
  data() {
    return {
      filter: '',
      total: 0,
      perPage: 10,
      currentPage: 1,
      lastPage: 0,
      firstPageUrl: null,
      lastPageUrl: null,
      nextPageUrl: null,
      prevPageUrl: null,
      isLoading: false,
      sortBy: '',
      sortDesc: false,
      selectedCardOption: '',
      rowToUpdate: null,
      modalVisible: false,
      modalVisibleDoument: false,
      editMode: false,
      users: [],
      notifications: [],
      assignManagerModal: false,
      managerList: [],
      selectedManagerId: null,
      selectedItemId: null, // the row for which you're assigning manager
      loadingManagerList: false,
      fields: [
        { key: 'id', sortable: true },
        // { key: "company_name", sortable: true },
        { key: 'types', sortable: true },
        { key: 'owner_name', label: 'Owner Name', sortable: true },
        { key: 'Category_title', label: 'Category', sortable: true },
        { key: 'brand.name', label: 'Brand', sortable: true },
        { key: 'model.title', label: 'Model', sortable: true },
        { key: 'color', sortable: true },
        { key: 'license_plate', sortable: true },
        { key: 'SystemNo', sortable: true },
        { key: 'InvoiceNo', label: 'Invoice Number', sortable: true },
        { key: 'registration_number', sortable: true },
        { key: 'vin', label: 'Vehicle Identification Number', sortable: true },
        { key: 'uic', label: 'Unique Identification Code', sortable: true },
        { key: 'year', sortable: true },
        { key: 'created_at', label: 'Date', formatter: this.formatDate },
        { key: 'created_at_time', label: 'Time' },
        { key: 'user.type', label: 'User Type', sortable: true },
        { key: 'stolen_location', sortable: true },
        { key: 'status', sortable: true },
        { key: 'manager', label: 'Manager Assign', sortable: false },
        { key: 'actions', label: 'Actions' },
      ],
      columnColors: {
        owner_name: 'blue',
        Category_title: 'green',
        brand_name: 'red',
        model_title: 'purple',
        color: 'orange',
        license_plate: 'brown',
        registration_number: 'blue',
        vin: 'teal',
        uic: 'blueviolet',
        year: 'gray',
        created_at: 'maroon',
        created_at_time: 'navy',
        user_type: 'olive',
        stolen_location: 'lime',
        status: 'indigo',
        // SystemNo: 'green',
        types: 'coral',
        actions: 'gold',
      },
      showDeleteConfirmations: false,
      itemIdToDelete: null,
      loading: false,
      startDateFilter: null,
      endDateFilter: null,
      ended_date: '',
      selected_date: '',
      your_vehicle_id: null,
      company_name: '',
      model: '',
      color: '',
      license_plate: '',
      make: '',
      types: '',
      registration_number: '',
      vin: '',
      uic: '',
      year: '',
      status: '',
      SystemNo: '',
      InvoiceNo: '',
      showModal: false,
      selectedVehicleId: null,
      pusher: null,
      channel: null,
      adminSound: null,
      type: '',
      locationData: null,
      selectedSystemItem: null,
      addSystemNo: false,
      addInvoiceNo: false,
      first_name: '',

      deletedVehiclesDismissed: false,
      deletedVehiclesExpanded: false,
      deletedVehiclesLoading: false,
      deletedVehiclesList: [],
      deletedVehiclesFilter: '',
      deletedVehiclesActiveSearch: '',
      deletedVehiclesStartDate: null,
      deletedVehiclesEndDate: null,
      deletedVehiclesCurrentPage: 1,
      deletedVehiclesTotal: 0,
      deletedVehiclesPerPage: 20,
      deletedVehiclesFields: [
        { key: 'id', label: 'ID', sortable: true },
        { key: 'brand_model', label: 'Brand / Model', sortable: true },
        { key: 'vin', label: 'VIN', sortable: true },
        { key: 'license_plate', label: 'License', sortable: true },
        { key: 'owner_display', label: 'Owner', sortable: true },
        { key: 'status', label: 'Status', sortable: true },
        { key: 'deleted_at_display', label: 'Archived at', sortable: true },
        { key: 'actions', label: 'Option' },
      ],
      showRestoreVehicleModal: false,
      restoreVehicleId: null,
      restoreVehicleSubmitting: false,
    }
  },
  computed: {
    sortOptions() {
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    rows() {
      return this.users.length
    },
  },

  mounted() {
    this.fetchData()
    this.preFillVin()
  },
  methods: {
    // Pre-fill the VIN in the search input field from the route params

    handleSystemNo(item) {
      this.selectedSystemItem = item
      this.SystemNo = item.SystemNo
      this.addSystemNo = true
    },
    confirmSystemNo() {
      this.loading = true
      const payload = {
        SystemNo: this.SystemNo,
      }

      axios.post(`vehicleUpdate/${this.selectedSystemItem.id}`, payload)
        .then(response => {
          this.$bvToast.toast('System No updated successfully!', { variant: 'primary' })
          this.fetchData() // refresh table
        })
        .catch(error => {
          if (error.response && error.response.data && error.response.data.message === 'This System number is already exist') {
            this.$bvToast.toast('This System number already exists. Please enter a different number.', { variant: 'danger' })
          } else {
            this.$bvToast.toast('Failed to update System No.', { variant: 'danger' })
            console.error(error)
          }
        })
        .finally(() => {
          this.addSystemNo = false
          this.loading = false
        })
    },
    handleInvoiceNo(item) {
      this.selectedInvoiceItem = item
      this.InvoiceNo = item.InvoiceNo
      this.addInvoiceNo = true
    },
    confirmInvoiceNo() {
      this.loading = true
      const payload = {
        InvoiceNo: this.InvoiceNo,
      }

      axios.post(`vehicleUpdate/${this.selectedInvoiceItem.id}`, payload)
        .then(response => {
          this.$bvToast.toast('Invoice No updated successfully!', { variant: 'primary' })
          this.fetchData() // refresh table
        })
        .catch(error => {
          if (error.response && error.response.data && error.response.data.message === 'This Invoice number is already exist') {
            this.$bvToast.toast('This Invoice number already exists. Please enter a different number.', { variant: 'danger' })
          } else {
            this.$bvToast.toast('Failed to update Invoice No.', { variant: 'danger' })
            console.error(error)
          }
        })
        .finally(() => {
          this.addInvoiceNo = false
          this.loading = false
        })
    },

    preFillVin() {
      const { vin } = this.$route.params
      if (vin) {
        this.filter = vin
      }
    },
    clearFilter() {
      this.filter = ''
      this.currentPage = 1
      this.fetchData()
    },
    showTheftModal(vehicleId) {
      this.playAdminSound()
      this.selectedVehicleId = vehicleId
      this.showModal = true
    },
    confirmTheft() {
      this.theftVehicle(this.selectedVehicleId)
      this.showModal = false
    },
    theftVehicle(vehicleId) {
      this.isLoading = true
      const payload = {
        status: 'stolen',
      }

      axios.post(`forwardNotification/${vehicleId}`, payload)
        .then(response => {
          this.$bvToast.toast('Vehicle marked as stolen successfully!', { variant: 'primary' })
          this.fetchData()
        })
        .catch(error => {
          console.error('Error marking vehicle as stolen', error)
          this.$bvToast.toast('Failed to mark vehicle as stolen', { variant: 'danger' })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    async fetchData() {
      this.loading = true
      const apiUrl = 'Vehicleindex'
      try {
        const response = await axios.get(apiUrl, {
          params: {
            page: this.currentPage,
            per_page: this.perPage,
            ended_date: this.endDateFilter,
            selected_date: this.startDateFilter,
          },
        })

        this.users = response.data.data
        this.total = response.data.total
        this.currentPage = response.data.current_page
        this.perPage = response.data.per_page
        this.lastPage = response.data.last_page
      } catch (error) {
        console.error('Error fetching data:', error)
      } finally {
        this.loading = false
      }
    },

    pageChanged(newPage) {
      this.currentPage = newPage
      this.fetchData()
    },
    // import  code
    triggerFileInput() {
      this.$refs.fileInput.click()
    },
    handleFileUpload(event) {
      const file = event.target.files[0]
      if (file && file.type === 'text/csv') {
        this.fileToUpload = file
        this.importStudents()
      } else {
        alert('Please select a valid CSV file.')
      }
    },
    async importStudents() {
      const formData = new FormData()
      formData.append('file', this.fileToUpload)

      this.loading = true

      try {
        const response = await axios.post('importParents', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })

        this.$bvToast.toast('File uploaded successfully.', {
          title: 'Success',
          variant: 'primary',
          solid: true,
          appendToast: true,
          toaster: 'b-toaster-top-right',
          autoHideDelay: 5000,
        })
      } catch (error) {
        this.$bvToast.toast('Failed to upload CSV file.', {
          title: 'Error',
          variant: 'danger',
          solid: true,
          appendToast: true,
          toaster: 'b-toaster-top-right',
          autoHideDelay: 5000,
        })
      } finally {
        this.loading = false
      }
    },

    applyFilter() {
      this.loading = true
      const apiUrl = 'Vehicleindex'
      axios
        .get(apiUrl, {
          params: {
            search: this.filter,
          },
        })
        .then(response => {
          this.users = response.data.data
          this.total = response.data.total
          this.currentPage = response.data.current_page
        })
        .catch(error => {

        })
        .finally(() => {
          this.loading = false
        })
    },
    openModal() {
      this.resetFormFields()

      this.modalVisible = true
    },
    uploadDocuments() {
      this.resetUploadDocument()

      this.modalVisibleDoument = true
    },

    onFiltered(filteredItems) {
      this.total = filteredItems.length
      this.currentPage = 1
    },
    uploadDocuments(studentId) {
      this.resetUploadDocument()
      this.studentId = studentId
      this.modalVisibleDoument = true
    },
    resetUploadDocument() {
      this.documents = ''
      this.studentId = null
    },

    codeClick() {
      this.codeActive = !this.codeActive
    },
    exportAllDataToCSV() {
      this.fetchAllParents(allParents => {
        const csv = Papa.unparse(allParents)
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.setAttribute('download', 'exported_data.csv')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
    },
    fetchAllParents(callback) {
      axios
        .get('AllVehicleindex', { params: { per_page: this.totalRows } })
        .then(response => {
          callback(response.data.data)
        })
        .catch(error => {

        })
    },

    editUser(userId) {
      this.$router.push({ name: 'EditVehicle', params: { id: userId } })
    },

    showParent(userId) {
      this.$router.push({ name: 'ViewVehicle', params: { id: userId } })
    },
    showDeleteConfirmation(itemId) {
      this.itemIdToDelete = itemId
      this.showDeleteConfirmations = true
    },
    deleteItem(itemId) {
      this.itemIdToDelete = itemId
      axios
        .delete(`vehicleDelete/${itemId}`)
        .then(response => {
          this.showDeleteConfirmations = false
          this.fetchData()
        })
        .catch(error => {

        })
    },
    generatePdf(userId) {
      this.$router.push({ name: 'PdfUser', params: { id: userId } })
    },
    generatePdfSpanish(userId) {
      this.$router.push({ name: 'PdfUserSpanish', params: { id: userId } })
    },

    stolenVehicle(item) {
      this.$router.push({
        name: 'StolenVehicle',
        params: {
          id: item.id,
        },
        query: {
          stolen_location: item.stolen_location,
          latitude: item.latitude,
          longitude: item.longitude,
        },
      })
    },

    handleApproved(item) {
      this.$router.push({
        name: 'ViewUser',
        params: {
          id: item.user_id,
        },
        query: {
          vehicle_id: item.id,
        },
      })
    },

    // .......................................................
    downloadFile(fileUrl) {
      const link = document.createElement('a')
      link.href = `https://boltapi.fastnetstaffing.in/${fileUrl}`
      link.download = 'downloaded_file'
      link.target = '_blank'
      link.click()
    },

    handleButtonClick(item) {
      this.updateStatus(item)
      this.toggleCardModal(item)
    },
    updateStatus(user) {
      user.status = user.status === 'Approved' ? 'Pending' : 'Approved'
      axios
        .post(`registrationUpdate/${user.id}`, user)
        .then(response => {

        })
        .catch(error => {

        })
    },
    toggleCardModal(item) {
      this.selectedCardOption = ''
      this.rowToUpdate = item
      this.isCardModalVisible = true
    },

    formatDate(dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      return date.toISOString().split('T')[0]
    },

    formatTime(dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    },
    changeDate() {
      const userId = this.$route.params.id
      this.fetchData(userId)
    },
    playAdminSound() {
      // Stop any previous sound before playing a new one
      this.stopSounds()
      this.adminSound = new Audio('/admin_notification.mp3')
      this.adminSound.play().catch(error => {
        console.error('Error playing sound:', error)
      })
    },

    stopSounds() {
      // Stop the current sound if it is already playing
      if (this.adminSound) {
        this.adminSound.pause()
        this.adminSound.currentTime = 0
      }
    },
    async openManagerAssignModal(item) {
      this.selectedItemId = item.id
      this.assignManagerModal = true
      this.loadingManagerList = true

      try {
        const response = await axios.get('/getManagementUserList')
        this.managerList = response.data.data
      } catch (error) {
        console.error('Error fetching managers:', error)
        this.$bvToast.toast('Failed to load managers', { variant: 'danger', solid: true })
      } finally {
        this.loadingManagerList = false
      }
    },

    async assignManager() {
      if (!this.selectedManagerId) return

      try {
        await axios.post('/assignManager', {
          vehicle_id: this.selectedItemId,
          manager_id: this.selectedManagerId,
        })
        this.$bvToast.toast('Manager assigned successfully', { variant: 'primary', solid: true })
        this.assignManagerModal = false
        this.selectedManagerId = null
        this.selectedItemId = null
        this.fetchData() // refresh table data
      } catch (err) {
        console.error(err)
        this.$bvToast.toast('Error assigning manager', { variant: 'danger', solid: true })
      }
    },
    toggleDeletedVehiclesExpand() {
      this.deletedVehiclesExpanded = !this.deletedVehiclesExpanded
      if (this.deletedVehiclesExpanded) {
        this.fetchDeletedVehicles()
      }
    },
    deletedVehiclesPageChanged(page) {
      this.deletedVehiclesCurrentPage = page
      this.fetchDeletedVehicles()
    },
    applyDeletedVehiclesSearch() {
      this.deletedVehiclesActiveSearch = this.deletedVehiclesFilter
      this.deletedVehiclesCurrentPage = 1
      this.fetchDeletedVehicles()
    },
    clearDeletedVehiclesSearch() {
      this.deletedVehiclesFilter = ''
      this.deletedVehiclesActiveSearch = ''
      this.deletedVehiclesCurrentPage = 1
      this.fetchDeletedVehicles()
    },
    clearDeletedVehiclesDateFilter() {
      this.deletedVehiclesStartDate = null
      this.deletedVehiclesEndDate = null
      this.deletedVehiclesCurrentPage = 1
      this.fetchDeletedVehicles()
    },
    relativeDeletedVehicleAt(iso) {
      if (!iso) return '—'
      const t = new Date(iso).getTime()
      if (Number.isNaN(t)) return '—'
      const sec = Math.floor((Date.now() - t) / 1000)
      if (sec < 45) return 'just now'
      if (sec < 3600) {
        const m = Math.floor(sec / 60)
        return `${m} min ago`
      }
      if (sec < 86400) {
        const h = Math.floor(sec / 3600)
        return `${h} hour${h === 1 ? '' : 's'} ago`
      }
      const d = Math.floor(sec / 86400)
      if (d < 30) return `${d} day${d === 1 ? '' : 's'} ago`
      const mo = Math.floor(d / 30)
      if (mo < 12) return `${mo} mo ago`
      const y = Math.floor(mo / 12)
      return `${y} yr ago`
    },
    parseDeletedVehiclesPagination(body) {
      if (!body) {
        return {
          rows: [], total: 0, perPage: 20, currentPage: 1, lastPage: 1,
        }
      }
      if (body.meta && Array.isArray(body.data)) {
        return {
          rows: body.data,
          total: body.meta.total,
          perPage: body.meta.per_page,
          currentPage: body.meta.current_page,
          lastPage: body.meta.last_page,
        }
      }
      if (Array.isArray(body.data)) {
        return {
          rows: body.data,
          total: body.total != null ? body.total : 0,
          perPage: body.per_page != null ? body.per_page : 20,
          currentPage: body.current_page != null ? body.current_page : 1,
          lastPage: body.last_page != null ? body.last_page : 1,
        }
      }
      return {
        rows: [], total: 0, perPage: 20, currentPage: 1, lastPage: 1,
      }
    },
    mapDeletedVehicleRows(items) {
      return (items || []).map(v => {
        const owner = v.user
          ? [v.user.first_name, v.user.second_name, v.user.last_name, v.user.second_last_name].filter(Boolean).join(' ')
                        || v.user.email
          : '—'
        const brandModel = [v.brand && v.brand.name, v.model && v.model.title].filter(Boolean).join(' ') || '—'
        return {
          ...v,
          owner_display: owner,
          brand_model: brandModel,
          deleted_at_display: this.relativeDeletedVehicleAt(v.deleted_at),
        }
      })
    },
    buildDeletedVehiclesRequestParams() {
      const params = {
        page: this.deletedVehiclesCurrentPage,
      }
      if (this.deletedVehiclesActiveSearch) {
        params.search = this.deletedVehiclesActiveSearch
      }
      if (this.deletedVehiclesStartDate && this.deletedVehiclesEndDate) {
        params.selected_date = this.deletedVehiclesStartDate
        params.ended_date = this.deletedVehiclesEndDate
      }
      return params
    },
    async fetchDeletedVehicles() {
      if (!this.deletedVehiclesExpanded) return
      this.deletedVehiclesLoading = true
      try {
        const response = await axios.get('deletedVehicles', {
          params: this.buildDeletedVehiclesRequestParams(),
        })
        const body = response.data
        const parsed = this.parseDeletedVehiclesPagination(body)
        this.deletedVehiclesList = this.mapDeletedVehicleRows(parsed.rows)
        this.deletedVehiclesTotal = parsed.total
        this.deletedVehiclesPerPage = parsed.perPage
        this.deletedVehiclesCurrentPage = parsed.currentPage
      } catch (e) {
        this.deletedVehiclesList = []
        this.deletedVehiclesTotal = 0
        this.$bvToast.toast('Could not load deleted vehicles.', {
          variant: 'danger',
          solid: true,
          toaster: 'b-toaster-top-right',
        })
      } finally {
        this.deletedVehiclesLoading = false
      }
    },
    deletedVehiclesExportRows() {
      return this.deletedVehiclesList.map(v => ({
        id: v.id,
        brand_model: v.brand_model,
        vin: v.vin || '',
        license_plate: v.license_plate || '',
        owner: v.owner_display,
        status: v.status || '',
        archived_at: v.deleted_at || '',
      }))
    },
    async copyDeletedVehiclesTable() {
      const rows = this.deletedVehiclesExportRows()
      if (!rows.length) {
        this.$bvToast.toast('Nothing to copy.', { variant: 'warning', solid: true, toaster: 'b-toaster-top-right' })
        return
      }
      const header = Object.keys(rows[0]).join('\t')
      const lines = rows.map(r => Object.values(r).join('\t'))
      try {
        await navigator.clipboard.writeText([header, ...lines].join('\n'))
        this.$bvToast.toast('Copied to clipboard.', { variant: 'primary', solid: true, toaster: 'b-toaster-top-right' })
      } catch (err) {
        this.$bvToast.toast('Copy failed.', { variant: 'danger', solid: true, toaster: 'b-toaster-top-right' })
      }
    },
    exportDeletedVehiclesCsv() {
      const rows = this.deletedVehiclesExportRows()
      if (!rows.length) {
        this.$bvToast.toast('No data to export.', { variant: 'warning', solid: true, toaster: 'b-toaster-top-right' })
        return
      }
      const csv = Papa.unparse(rows)
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = 'deleted-vehicles.csv'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    exportDeletedVehiclesExcel() {
      const rows = this.deletedVehiclesExportRows()
      if (!rows.length) {
        this.$bvToast.toast('No data to export.', { variant: 'warning', solid: true, toaster: 'b-toaster-top-right' })
        return
      }
      const csv = `\ufeff${Papa.unparse(rows)}`
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = 'deleted-vehicles-excel.csv'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    async exportDeletedVehiclesPdf() {
      const el = this.$refs.deletedVehiclesPdf
      if (!el || !this.deletedVehiclesList.length) {
        this.$bvToast.toast('No data for PDF.', { variant: 'warning', solid: true, toaster: 'b-toaster-top-right' })
        return
      }
      const html2pdf = (await import('html2pdf.js')).default
      await html2pdf()
        .from(el)
        .set({
          margin: 8,
          filename: 'deleted-vehicles.pdf',
          html2canvas: { scale: 2 },
          jsPDF: { unit: 'mm', format: 'a4', orientation: 'landscape' },
        })
        .save()
    },
    printDeletedVehiclesTable() {
      const el = this.$refs.deletedVehiclesPdf
      if (!el || !this.deletedVehiclesList.length) {
        this.$bvToast.toast('Nothing to print.', { variant: 'warning', solid: true, toaster: 'b-toaster-top-right' })
        return
      }
      const w = window.open('', '_blank')
      if (!w) return
      w.document.write(`<!DOCTYPE html><html><head><title>Deleted vehicles</title></head><body>${el.innerHTML}</body></html>`)
      w.document.close()
      w.focus()
      w.print()
      w.close()
    },
    openRestoreVehicleModal(item) {
      this.restoreVehicleId = item.id
      this.showRestoreVehicleModal = true
    },
    async confirmRestoreVehicle() {
      if (!this.restoreVehicleId) return
      this.restoreVehicleSubmitting = true
      try {
        await axios.post(`restoreVehicle/${this.restoreVehicleId}`)
        this.$bvToast.toast('Vehicle restored successfully.', {
          variant: 'success',
          solid: true,
          toaster: 'b-toaster-top-right',
        })
        this.showRestoreVehicleModal = false
        this.restoreVehicleId = null
        this.fetchDeletedVehicles()
        this.fetchData()
      } catch (error) {
        const data = error.response && error.response.data
        const msg = data && data.message ? data.message : 'Restore failed.'
        this.$bvToast.toast(msg, { variant: 'danger', solid: true, toaster: 'b-toaster-top-right' })
      } finally {
        this.restoreVehicleSubmitting = false
      }
    },
  },

}
</script>
  <style>
  /* Zebra striping */
  .custom-zebra tbody tr:nth-of-type(odd) {
    background-color: #f0f2f5; /* darker than default */
  }

  /* Hover effect */
  .custom-zebra tbody tr:hover {
    background-color: #e0e4ea !important; /* slightly darker hover */
  }

  .deleted-archive-panel {
    border: 1px solid #e2e5ea;
    border-radius: 6px;
    background: #fafbfc;
  }
  .deleted-archive-header {
    background: #f4f5f7;
    border-radius: 6px 6px 0 0;
    border-bottom: 1px solid #e2e5ea;
  }
  .deleted-archive-body {
    background: #fff;
    border-radius: 0 0 6px 6px;
  }
  .archive-toggle-btn {
    min-width: 2rem;
    font-weight: 600;
    line-height: 1.2;
  }
  .letter-spacing {
    letter-spacing: 0.04em;
  }
  .restore-action-btn {
    color: #2c7be5;
  }
  .restore-action-btn:hover {
    color: #1a68d1;
  }
  </style>
